module.exports = __webpack_public_path__ + "img/hero-spritz.ca754a32.jpg";